import { Link } from "react-router-dom";
import { useUserContext } from "../contexts";
import { InlineLogo } from "./Logos";

function NavItem({ to, children }) {
  return (
    <li>
      <Link
        to={to}
        className="text-gray-600 hover:text-gray-400 p-4 font-medium text-sm"
      >
        {children}
      </Link>
    </li>
  );
}

export default function Nav() {
  const { user } = useUserContext();

  return (
    <nav className="p-4 bg-white">
      <div className="flex flex-col md:flex-row justify-between items-center max-w-7xl mx-auto">
        <Link to="/" className="mb-4 md:mb-0">
          <InlineLogo />
        </Link>
        <ul className="flex flex-wrap justify-center">
          <NavItem to="/">Home</NavItem>
          <NavItem to="/tasks">Tasks</NavItem>
          <NavItem to="/account">Account</NavItem>
          {user === null ? (
            <NavItem to="/login">Login</NavItem>
          ) : (
            <NavItem to="/logout">Logout</NavItem>
          )}
        </ul>
      </div>
    </nav>
  );
}
